<div class="login-register">
  @if (isUserLoggedIn | async) {
    <div class="account-dropdown" placement="bottom-end">
      <button
        type="button"
        class="login__button text-link"
        id="accountDropdown"
        data-internal-id="sign-in"
        (click)="goToAccount()"
      >
        <img class="d-none d-lg-block" alt="login icon" [src]="'assets/images/icons/login-full.svg' | staticFileHash" />
        <i class="fas fa-circle-user d-lg-none"></i>
      </button>
    </div>
  } @else {
    <button
      aria-label="Logging"
      type="button"
      data-internal-id="sign-in"
      class="login__button text-link"
      i18n-title="@@LOGIN"
      (click)="goToLogin()"
    >
      <img class="d-none d-lg-block" alt="login icon" [src]="'assets/images/icons/login.svg' | staticFileHash" />
      <i class="fal fa-circle-user d-lg-none"></i>
      @if (showAssociatedText) {
        <span class="login__button-text" i18n="@@LOGIN">Login</span>
      }
    </button>
    <span> | </span>
    <button
      aria-label="Logging"
      type="button"
      data-internal-id="sign-in"
      class="register__button text-link"
      i18n-title="@@REGISTER"
      (click)="goToSignUp()"
    >
      @if (showAssociatedText) {
        <span class="register__button-text" i18n="@@REGISTER">Register</span>
      }
    </button>
  }
</div>
